import { useModalContext } from 'utils/contexts/modal';
import { DeleteAdAccountType, FacebookModalState } from '../../domain/modal';
import { FacebookIntegrationModal } from './FacebookIntegrationModal';
import { useFacebookIntegrationContext } from '../../contexts/FacebookIntegrationContext';

const isDeleteAccountModalVisible = (
  modalState: FacebookModalState | null,
): modalState is DeleteAdAccountType => !!modalState && 'id' in modalState && !!modalState.id;

export const DeleteAccountModal = () => {
  const { hideModal, modalState } = useModalContext<FacebookModalState>();
  const { removeFacebookIntegration } = useFacebookIntegrationContext();

  if (!isDeleteAccountModalVisible(modalState)) return null;

  const buttonSubmitHandler = (deleteId: number) => {
    removeFacebookIntegration(deleteId);
    hideModal();
  };

  const modalContent = {
    header: 'Please Confirm',
    content: `Are you sure you want to delete this Ad Account with Iterable ID: ${modalState.id}?`,
    submitButtonText: 'Yes',
    cancelButtonText: 'No',
    submitButtonAppearance: 'default',
    cancelButtonAppearance: 'primary',
  };

  return (
    <FacebookIntegrationModal
      isVisible
      buttonSubmitHandler={() => buttonSubmitHandler(modalState.id)}
      hideModal={hideModal}
      displayContent={modalContent}
    />
  );
};
